/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Crosspostinghelpfbwhyperson4Inputs */

const en_crosspostinghelpfbwhyperson4 = /** @type {(inputs: Crosspostinghelpfbwhyperson4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why your profile and not just the Page? Facebook doesn't connect the Page on its own - it connects your login. The app posts on behalf of your profile, using your rights on the Page. Without full control, posting is blocked. Check: Page settings → Page access → People with Facebook access → your profile → Full control.`)
};

const de_crosspostinghelpfbwhyperson4 = /** @type {(inputs: Crosspostinghelpfbwhyperson4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum dein Profil und nicht nur die Seite? Facebook verbindet nicht die Seite allein, sondern deine Anmeldung. Die App postet im Namen deines Profils – mit deinen Rechten auf der Seite. Ohne volle Kontrolle ist Posten gesperrt. Prüfen: Seiteneinstellungen → Seitenzugriff → Personen mit Facebook-Zugriff → dein Profil → Uneingeschränkter Zugriff.`)
};

/**
* | output |
* | --- |
* | "Why your profile and not just the Page? Facebook doesn't connect the Page on its own - it connects your login. The app posts on behalf of your profile, using..." |
*
* @param {Crosspostinghelpfbwhyperson4Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const crosspostinghelpfbwhyperson4 = /** @type {((inputs?: Crosspostinghelpfbwhyperson4Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Crosspostinghelpfbwhyperson4Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_crosspostinghelpfbwhyperson4(inputs)
	return de_crosspostinghelpfbwhyperson4(inputs)
});
export { crosspostinghelpfbwhyperson4 as "crosspostingHelpFbWhyPerson" }